export const leaveRouting = [
  {
    path: "/attendance/leave/list",
    name: "attendance-leave-list",
    meta: { title: "请假申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/leave/create",
    name: "attendance-leave-create",
    meta: { title: "新建请假申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/leave/edit/:id",
    name: "attendance-leave-edit",
    meta: { title: "编辑请假申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/leave/detail/:id",
    name: "attendance-leave-detail",
    meta: { title: "请假申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/leave/flowPrint/:id",
    name: "attendance-leave-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-overtime" */ "@/views/attendance-management/leave-application/flow-print/index.vue"
        ),
  },
];
